import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_ce86yex9ah: FaireBrandEntity = {
  token: "b_ce86yex9ah",
  type: "brand",
  name: "Biology Functional Fragrances",
  avatarUrl:
    "https://cdn.faire.com/fastly/cb50366e00f0d8440fd684c6080b2fd8294c6da0c2ed95ac404129ea9363937b.png",
  bannerUrl:
    "https://cdn.faire.com/fastly/3ac3ea8d0d3fb72bc451cdbf9fba0a9afadd1463687408bb410cd7172262bec7.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/cb50366e00f0d8440fd684c6080b2fd8294c6da0c2ed95ac404129ea9363937b.png",
  heroImageUrl:
    "https://cdn.faire.com/fastly/3ac3ea8d0d3fb72bc451cdbf9fba0a9afadd1463687408bb410cd7172262bec7.jpeg",
  location: "GLENDALE, CA, USA",
  minimumOrderDollars: 96,
  rating: 5,
  reviewCount: 4,
  isTopShop: true,
  isInsider: true,
  description:
    "BIOLOGY IS A SMALL BATCHED FUNCTIONAL FRAGRANCE COLLECTION.\n\nWe believe fragrances should enhance more than just scent. Our fragrances are formulated to provide you with that extra boost to tackle the day. \nOur fragrances are meant to be carried around with you, reapply whenever and wherever depending on your mood.\n\nNatural, Paraben Free, Phthalate Free, No Endocrine Disruptors\n\nwww.biologyfragrances.com",
  meta: {
    source: "api",
    importedAt: "2026-07-23T05:56:09.682Z",
    importedBy: "entity-db-cli",
  },
};
